"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coin = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var coin = function coin(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'coin-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M9.72607 14.7627H10.3438V13.9033C11.8691 13.8013 12.9595 12.9849 12.9595 11.6367C12.9595 10.4604 12.1914 9.86963 10.7251 9.53662L10.3438 9.45605V7.56006C10.9453 7.646 11.3481 7.979 11.4233 8.55908H12.8574C12.8037 7.2915 11.8369 6.45361 10.3438 6.34619V5.4707H9.72607V6.34082C8.24902 6.43213 7.19092 7.26465 7.19092 8.54834C7.19092 9.7085 7.96436 10.3369 9.36621 10.6538L9.72607 10.7397V12.7002C8.99561 12.6196 8.60889 12.2383 8.52295 11.6904H7.0835C7.12109 13.0332 8.2168 13.8228 9.72607 13.9087V14.7627ZM8.69482 8.40869C8.69482 7.979 9.04932 7.62988 9.72607 7.54932V9.31104C9.00098 9.11768 8.69482 8.83838 8.69482 8.40869ZM11.4609 11.8032C11.4609 12.292 11.0903 12.625 10.3438 12.7002V10.8794C11.1763 11.0889 11.4609 11.3306 11.4609 11.8032Z',
    fill: '#4B5563'
  }));
};

exports.coin = coin;